import {
  createSlice,
  createAsyncThunk,
  createSelector,
} from "@reduxjs/toolkit";
import axios from "axios";
const APIURL = process.env.REACT_APP_API_URL_LOCAL;

// ** Fetch Users
export const fetchCountOnlineDevices = createAsyncThunk(
  "fetchCountOnlineDevices",
  async ({ headers, params }) => {
    const config = {
      headers: { ...headers },
      params: params,
    };
    try {
      const data = await axios.get(`${APIURL}/devices/onlinecount`, config);
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const fetchDevices = createAsyncThunk(
  "fetchDevices",
  async ({ headers, params }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${APIURL}/devices/list`, {
        headers,
        params,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deviceSlice = createSlice({
  name: "device",
  initialState: {
    devices: [],
    onlinedevices: 0,
    currentlyWatchingPlaylistChannel: 0,
    currentlyWatchingSingleChannel: 0,
    currentlyWatchingLiveChannel: 0,
    currentlyWatchingMovie: 0,
    currentlyWatchingSeries: 0,
    androidCount: 0,
    appleCount: 0,
    tvCount: 0,
    appleTvCount: 0,
    subscriptionCount: 0,
    weeklyCount: 0,
    monthlyCount: 0,
    yearlyCount: 0,
    lifetimeCount: 0,
    onlineAndroidCount: 0,
    onlineAppleCount: 0,
    onlineTVCount: 0,
    onlineAppleTVCount: 0,
    androidSubscriptionCount: 0,
    appleSubscriptionCount: 0,
    androidTVSubscriptionCount: 0,
    appleTVSubscriptionCount: 0,
    total: 0,
    limit: 10,
    page: 1,
    deviceDetail: {},
  },
  reducers: {
    changeLimit: (state, action) => {
      state.limit = action.payload;
    },
    changePage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCountOnlineDevices.fulfilled, (state, action) => {
      if (action?.payload.status == 403) {
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
      }
      if (action?.payload?.data?.success) {
        state.onlinedevices = action?.payload?.data?.result.onlineCount;
        state.total = action?.payload?.data?.result.total;
        state.currentlyWatchingPlaylistChannel =
          action?.payload?.data?.result.currentlyWatchingPlaylistChannel;
        state.currentlyWatchingSingleChannel =
          action?.payload?.data?.result.currentlyWatchingSingleChannel;
        state.currentlyWatchingLiveChannel =
          action?.payload?.data?.result.currentlyWatchingLiveChannel;
        state.currentlyWatchingMovie =
          action?.payload?.data?.result.currentlyWatchingMovie;
        state.currentlyWatchingSeries =
          action?.payload?.data?.result.currentlyWatchingSeries;
        state.androidCount = action?.payload?.data?.result.androidCount;
        state.appleCount = action?.payload?.data?.result.appleCount;
        state.tvCount = action?.payload?.data?.result.tvCount;
        state.appleTvCount = action?.payload?.data?.result.appleTvCount;
        state.subscriptionCount =
          action?.payload?.data?.result.subscriptionCount;
        state.weeklyCount = action?.payload?.data?.result.weeklyCount;
        state.monthlyCount = action?.payload?.data?.result.monthlyCount;
        state.yearlyCount = action?.payload?.data?.result.yearlyCount;
        state.lifetimeCount = action?.payload?.data?.result.lifetimeCount;
        state.onlineAndroidCount =
          action?.payload?.data?.result.onlineAndroidCount;
        state.onlineAppleCount = action?.payload?.data?.result.onlineAppleCount;
        state.onlineTVCount = action?.payload?.data?.result.onlineTVCount;
        state.onlineAppleTVCount =
          action?.payload?.data?.result.onlineAppleTVCount;
        state.androidSubscriptionCount =
          action?.payload?.data?.result.androidSubscriptionCount;
        state.appleSubscriptionCount =
          action?.payload?.data?.result.appleSubscriptionCount;
        state.androidTVSubscriptionCount =
          action?.payload?.data?.result.androidTVSubscriptionCount;
        state.appleTVSubscriptionCount =
          action?.payload?.data?.result.appleTVSubscriptionCount;
      }
    });

    builder.addCase(fetchDevices.fulfilled, (state, action) => {
      if (action?.payload.status == 403) {
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
      }
      if (action?.payload?.success) {
        state.devices = action?.payload?.result.devices;
        state.total = action?.payload?.result.total;
      }
    });

    builder.addCase(fetchDevices.rejected, (state, action) => {
      console.error("Fetch devices failed:", action.payload);
    });
  },
});

export const { changeLimit, changePage } = deviceSlice.actions;
export default deviceSlice.reducer;

export const deviceSelector = createSelector(
  (state) => state.device.devices,
  (state) => state.device.onlinedevices,
  (state) => state.device.total,
  (state) => state.device.limit,
  (state) => state.device.page,
  (state) => state.device.deviceDetail,
  (state) => state.device.currentlyWatchingPlaylistChannel,
  (state) => state.device.currentlyWatchingSingleChannel,
  (state) => state.device.currentlyWatchingLiveChannel,
  (state) => state.device.currentlyWatchingMovie,
  (state) => state.device.currentlyWatchingSeries,
  (state) => state.device.androidCount,
  (state) => state.device.appleCount,
  (state) => state.device.tvCount,
  (state) => state.device.appleTvCount,
  (state) => state.device.subscriptionCount,
  (state) => state.device.weeklyCount,
  (state) => state.device.monthlyCount,
  (state) => state.device.yearlyCount,
  (state) => state.device.lifetimeCount,
  (state) => state.device.onlineAndroidCount,
  (state) => state.device.onlineAppleCount,
  (state) => state.device.onlineTVCount,
  (state) => state.device.onlineAppleTVCount,
  (state) => state.device.androidSubscriptionCount,
  (state) => state.device.appleSubscriptionCount,
  (state) => state.device.androidTVSubscriptionCount,
  (state) => state.device.appleTVSubscriptionCount,
  (
    devices,
    onlinedevices,
    total,
    limit,
    page,
    deviceDetail,
    currentlyWatchingPlaylistChannel,
    currentlyWatchingSingleChannel,
    currentlyWatchingLiveChannel,
    currentlyWatchingMovie,
    currentlyWatchingSeries,
    androidCount,
    appleCount,
    tvCount,
    appleTvCount,
    subscriptionCount,
    weeklyCount,
    monthlyCount,
    yearlyCount,
    lifetimeCount,
    onlineAndroidCount,
    onlineAppleCount,
    onlineTVCount,
    onlineAppleTVCount,
    androidSubscriptionCount,
    appleSubscriptionCount,
    androidTVSubscriptionCount,
    appleTVSubscriptionCount
  ) => ({
    devices,
    onlinedevices,
    total,
    limit,
    page,
    deviceDetail,
    currentlyWatchingPlaylistChannel,
    currentlyWatchingSingleChannel,
    currentlyWatchingLiveChannel,
    currentlyWatchingMovie,
    currentlyWatchingSeries,
    androidCount,
    appleCount,
    tvCount,
    appleTvCount,
    subscriptionCount,
    weeklyCount,
    monthlyCount,
    yearlyCount,
    lifetimeCount,
    onlineAndroidCount,
    onlineAppleCount,
    onlineTVCount,
    onlineAppleTVCount,
    androidSubscriptionCount,
    appleSubscriptionCount,
    androidTVSubscriptionCount,
    appleTVSubscriptionCount,
  })
);
